import AbstractView from 'abstract';
import Vue from 'vue'
import store from 'definitions/store'

export class Main extends AbstractView {
    constructor(domElementId) {
        return super(domElementId);
    }

    init() {
        const LargeForm = () => import(/* webpackChunkName: "snippet-items-large-form" */ 'components/SnippetTemplate/Items/LargeForm')
        new Vue({
            el: "#" + this.elemId,
            store,
            render: h => h(LargeForm, {props: eval(this.elemId)})
        })
    }
}
